import { RadioField } from '@superdispatch/ui';
import { FormikRadioGroupField } from '@superdispatch/forms';

interface TrailerTypeFieldProps {
  name: string;
  disabled: boolean;
}

export function TrailerTypeField({ name, disabled }: TrailerTypeFieldProps) {
  return (
    <FormikRadioGroupField name={name} RadioGroupProps={{ row: true }}>
      <RadioField label="Open" value="Open" disabled={disabled} />
      <RadioField label="Enclosed" value="Enclosed" disabled={disabled} />
    </FormikRadioGroupField>
  );
}
